// extracted by mini-css-extract-plugin
export default {"container":"ComingSoon_container__4MQ1H","title":"ComingSoon_title__D2GJQ","text":"ComingSoon_text__JS+p2"};